import { useEffect } from 'react';
import { setNavigationTitle } from '../../Store/features/navigationHeader/navigationHeaderSlice';
import { RootState, useAppDispatch, useAppSelector } from '../../store';

interface AdminBoxHeadlineProps {
    headLine?: string;
    subLine?: string;
}

function AdminBoxHeadline({ headLine, subLine }: AdminBoxHeadlineProps) {
    const dispatch = useAppDispatch();
    const currentURL = useAppSelector((state: RootState) => state.environment.currentURL);

    useEffect(() => {
        dispatch(setNavigationTitle(`${headLine ?? ''}${subLine ? ' - ' + subLine : ''}`));
    }, [headLine, subLine, dispatch, currentURL]);

    return null;
}

export default AdminBoxHeadline;
